import React from 'react'

const SandClock = ({color = '#fff', ...props}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={12}
      height={19}
      viewBox="0 0 12 19"
      fill="none"
      {...props}
    >
      <path
        fill={color}
        d="M1.709 18.193C.654 18.193 0 17.588 0 16.475v-.186c0-2.412 2.53-4.932 3.809-6.191.664-.674.625-1.387 0-2.012C2.529 6.816 0 4.306 0 1.885v-.156C0 .615.654 0 1.709 0h8.242c1.065 0 1.71.615 1.71 1.729v.156c0 2.422-2.52 4.931-3.8 6.2-.625.626-.664 1.339 0 2.013 1.28 1.26 3.8 3.779 3.8 6.191v.186c0 1.113-.645 1.718-1.71 1.718H1.71Zm.82-1.523h6.602c.45 0 .566-.518.264-.8l-2.979-2.872c-.156-.146-.205-.195-.205-.43v-4.15c0-.479.098-.742.45-1.045.624-.547 1.513-1.318 2.08-1.934.273-.283.146-.644-.216-.644h-5.38c-.362 0-.499.361-.225.644.576.616 1.455 1.387 2.08 1.934.352.303.45.566.45 1.045v4.15c0 .235-.04.284-.206.43l-2.978 2.871c-.293.283-.176.8.263.8Z"
      />
    </svg>
  )
}

export default SandClock
